import { pageViewMixin } from "~/mixin/pageView";

// Ugly poll until predicate is true continuing, attempts 50 times at a 25 ms interval
function waitUntil(predicate, callback, counter) {
  counter++;
  if (counter > 50) {
    return;
  }
  if (predicate()) {
    callback();
  } else {
    setTimeout(() => waitUntil(predicate, callback, counter), 25);
  }
}

export default (ctx) => {
  const { app, store } = ctx;
  let firstRun = true;
  app.$isBefore = false;

  const beforeEachHook = (to, from, next) => {
    // Wait until someone's unset app.$isBefore (previous page track has gotten a context)
    waitUntil(
      () => !app.$isBefore,
      () => {
        app.$isBefore = true;
        waitUntil(
          () => {
            const front = store.getters["PageView/front"];
            return front !== to.path;
          },
          () => {
            next();
          },
          0
        );
      },
      0
    );
  };

  app.router.afterEach((to, _from) => {
    app.$isBefore = false;

    if (firstRun && process.client) {
      firstRun = false;
      // There was a reason for registering this only after the first page view.
      app.router.beforeEach(beforeEachHook);
    }

    to?.matched[0]?.components?.default?.mixin(pageViewMixin);
  });
};
